import {
  MainBar as MainBarTheme,
  Header,
  ActionBar,
  QuickNavigation,
  AuthLayout,
  MainLayout,
  Navigation as ThemeNavigation,
  PageContent,
  Sidebar,
  NotFound,
  Wrapper,
  WrapperData
} from './theme1/layout/components';

import { BarItems, MainWrapper, SidebarList } from './theme1/layout/styles';

import {
  Alert,
  confirm,
  arrayToObject,
  objectToArray,
  generateRandomColorCode
} from './theme1/common/utils';

import {
  Attachment,
  NameCard,
  Button,
  Label,
  Icon,
  BreadCrumb,
  BreadCrumbItem,
  Spinner,
  Tip,
  Chip,
  LoadMore,
  Pagination,
  ReportPagination,
  ModalTrigger,
  ActionButtons,
  EmptyState,
  Bulk,
  Filter,
  Tags,
  FilterableList,
  DropdownToggle,
  ImportFile,
  SettingTheme,
  ChooserSelector,
  FormControl,
  ControlLabel,
  FormGroup,
  Textarea,
  SelectWithSearch,
  SelectFilterAPI,
  Step,
  Steps,
  ConditionStep,
  TextDivider,
  CountsByTag,
  FilterByParams,
  Table,
  Tabs,
  TabList,
  TabTitle,
  ConfirmDialog,
  DataWithLoader,
  SortableList,
  ImageWithPreview,
  IntegrationIcon,
  Chooser,
  DateFilter,
  PhoneFilter,
  ModifiableSelect,
  SortHandler,
  ProjectFilter,
  AudioPlayer,
  ManageColumns,
  LoginFormTheme,
  DashboardTheme,
  HeaderDialpad,
  OfflineDialpad,
  CallHandlerTheme,
  BardgeButton,
  PreviewButton,
  CallInboundTheme,
  DTMFTheme,
  CallTagTheme,
  CallInfoTheme,
  AddCallTheme,
  AddNewCallTheme,
  FAQTheme,
  ChatListTheme,
  MessageListTheme,
  OnlineScreenTheme,
  EndCallProfileTheme,
  AdminDashboardTheme,
  EndCallAgentProfileTheme,
  EndCallChangePwdTheme,
  CallBreakTheme,
  CallBreakSelectTheme,
  CallDashboardTheme,
  ContactProfileTheme,
  ContactInfoActivityTheme,
  AgentDashboardTheme,
  ContactInfoActivityTimelineTheme,
  CallPreviewLoading,
} from './theme1/common/components';

import { APIManager } from './theme1/common/apiManager';

import {
  BoxRoot,
  FullContent,
  ModalFooter,
  InfoWrapper,
  Links,
  Well,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  CenterContent,
  ActivityContent,
  DropIcon,
  InfoWrapperP,
  ModalButtonDesign,
  SimpleButton,
  CloseModal,
  DataWrapperClass,
  Title,
  Column,
  Columns,
  OverflowClass,
  TagsStyle,
  ToggleArea,
  SkillWrapper,
  TableData
} from './theme1/common/styles/main';

import {
  colors,
  dimensions,
  typography,
  injectGlobal
} from './theme1/common/styles';

import { SeachForm } from './theme1/common/components/form/styles';

import {
  SortItem,
  SortableWrapper,
  DragHandler
} from './theme1/common/styles/sort';

import {
  MainBox,
  HeaderBar,
  TopBar,
  BodyBox
} from './theme1/common/styles/dialpadstyle'

export {
  //layout/components
  MainBarTheme,
  Header,
  ActionBar,
  QuickNavigation,
  AuthLayout,
  MainLayout,
  ThemeNavigation,
  NotFound,
  PageContent,
  Sidebar,
  Wrapper,
  WrapperData,
  //layout/styles
  BarItems,
  MainWrapper,
  SidebarList,
  //common/util
  Alert,
  confirm,
  arrayToObject,
  objectToArray,
  generateRandomColorCode,
  //common/components
  Attachment,
  ActionButtons,
  NameCard,
  Button,
  Label,
  Icon,
  BreadCrumb,
  BreadCrumbItem,
  Spinner,
  Tip,
  LoadMore,
  Chip,
  Pagination,
  ProjectFilter,
  ReportPagination,
  ModalTrigger,
  EmptyState,
  Bulk,
  CountsByTag,
  Filter,
  FilterByParams,
  Tags,
  FilterableList,
  DropdownToggle,
  FormControl,
  Textarea,
  ControlLabel,
  FormGroup,
  Step,
  Steps,
  ConditionStep,
  TextDivider,
  Table,
  Tabs,
  TabList,
  PhoneFilter,
  TabTitle,
  ConfirmDialog,
  DataWithLoader,
  SortableList,
  ImageWithPreview,
  IntegrationIcon,
  Chooser,
  DateFilter,
  ModifiableSelect,
  SortHandler,
  SelectWithSearch,
  SelectFilterAPI,
  ChooserSelector,
  AudioPlayer,
  ImportFile,
  SettingTheme,
  ManageColumns,
  LoginFormTheme,
  DashboardTheme,
  HeaderDialpad,
  OfflineDialpad,
  CallHandlerTheme,
  BardgeButton,
  PreviewButton,
  CallInboundTheme,
  DTMFTheme,
  CallTagTheme,
  CallInfoTheme,
  AddCallTheme,
  AddNewCallTheme,
  FAQTheme,
  ChatListTheme,
  MessageListTheme,
  OnlineScreenTheme,
  EndCallProfileTheme,
  AdminDashboardTheme,
  EndCallAgentProfileTheme,
  EndCallChangePwdTheme,
  CallBreakTheme,
  CallBreakSelectTheme,
  CallDashboardTheme,
  ContactProfileTheme,
  ContactInfoActivityTheme,
  AgentDashboardTheme,
  ContactInfoActivityTimelineTheme,
  CallPreviewLoading,
  //commom/apiManager
  APIManager,
  //common/styles/main
  BoxRoot,
  OverflowClass,
  FullContent,
  ModalFooter,
  InfoWrapper,
  Links,
  Well,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  CenterContent,
  ActivityContent,
  DropIcon,
  InfoWrapperP,
  ModalButtonDesign,
  SimpleButton,
  CloseModal,
  DataWrapperClass,
  Title,
  Column,
  Columns,
  TagsStyle,
  ToggleArea,
  SkillWrapper,
  TableData,
  //common/styles
  colors,
  dimensions,
  typography,
  injectGlobal,
  //commom/componnents/form/styles
  SeachForm,
  //common/styles/sort
  SortItem,
  SortableWrapper,
  DragHandler,
  //common/styles/dialpadstyles
  MainBox,
  HeaderBar,
  TopBar,
  BodyBox
};

export const app_theme = 'tcc';



// WEBPACK FOOTER //
// ./src/modules/theme/index.js